import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { FUEL_META } from './constants';  // Changé

const LowFuelAlert = ({ alerts }) => {
  if (alerts.length === 0) return null;
  
  return (
    <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-4 flex items-center gap-3">
      <AlertTriangle className="text-yellow-400 shrink-0" size={20} />
      <div>
        <p className="text-yellow-400 font-medium text-sm">Low fuel level detected</p>
        <p className="text-yellow-300/70 text-xs">
          {alerts.map(a => a.tank_name || FUEL_META[a.fuel_type]?.label || a.fuel_type).join(', ')} — reorder recommended
        </p>
      </div>
    </div>
  );
};

export default LowFuelAlert;